export function readFileAsDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      if (event.target?.result) {
        resolve(event.target.result as string)
      }
      else {
        reject(new Error('Failed to read the file.'))
      }
    }

    reader.onerror = () => {
      reject(new Error('Error reading the file.'))
    }

    reader.readAsDataURL(file)
  })
}
